let tidalTracks;
let tidalPlayer;
let mediaReady = false;
let playerStarted = false;
let seek_type = 'manual';

let apiUrl;
if (window.location.href.includes('localhost') || window.location.href.includes('ngrok')) {
  apiUrl = 'https://api.stage.tidal.com/v1'
} else {
  apiUrl = 'https://api.tidal.com/v1'
}

export const init = async (patch, audioPlayer, access_token) => {
  tidalTracks = await queueMedia(audioPlayer, access_token);

  if (!tidalTracks || tidalTracks.length < 1) {
    return false;
  }

  const tidalPlayer = await start(audioPlayer);
  sonikit.emit('playerReady', { service: 'tidal' });
  return tidalPlayer;
}

async function queueMedia(audioPlayer, access_token) {
  let tidalTrackCount = 0;

  let tidalAlbumArt;
  //GET ALBUM
  //	https://api.stage.tidal.com/v1
  const media = await fetch(`${apiUrl}/${audioPlayer.service.media_type}s/${audioPlayer.service.media_id}?countryCode=US`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${access_token}`,
      }
    })
    .then(response => response.json())
    .then(data => {
      // Set the number of tracks because the next call will default to a limit of 10
      tidalTrackCount = data.numberOfTracks;
      return data;
    })

  if (!media.id && !media.uuid) {
    // Playlists dont have an ID, they have uuid only
    return false;
  }

  // GET TRACKS
  // https://api.stage.tidal.com/v1
  const tracks = await fetch(`${apiUrl}/${audioPlayer.service.media_type}s/${audioPlayer.service.media_id}/items?countryCode=US&limit=${tidalTrackCount}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${access_token}`,
    }
  })
  .then(response => response.json())
  .then(data => {
    return data;
  })
  .catch(error => {
    console.log(error)
    return error;
  })

  if (!tracks.items || tracks.items.length < 1) {
    return false;
  }

  // GET STREAMING DATA
  const trackList = [];
  for (let index = 0; index < tracks.items.length; index++) {
    const track = tracks.items[index].item;
    //https://api.stage.tidal.com/v1
    const trackData = await fetch(`${apiUrl}/tracks/${track.id}/playbackinfopostpaywall?countryCode=US&playbackmode=STREAM&assetpresentation=FULL&audioquality=LOW`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${access_token}`,
      }
    })
    .then(response => response.json())
    .then(data => {
      const audioManifest = JSON.parse(atob(data.manifest));
      const audioSrc = audioManifest.urls[0];
      
      // TIDAL album call returns a cover ID with dashes (-),
      // these need to be replaced with backslashes for the image to work
      // You also need to add the base url and image size;
      //(REF: https://developer.tidal.com/technical/images/)
      const imgBaseUrl = 'https://resources.tidal.com/images/';
      const imgSize = '/1080x1080';
      const imgRegex = /-/gi;
      const formattedTidalCoverId = track.album.cover.replace(imgRegex, '/');
      tidalAlbumArt = imgBaseUrl+formattedTidalCoverId+imgSize+'.jpg';

      let tidalArtist;
      if (track.artists && track.artists.length > 1) {
        tidalArtist = track.artists.map(x => x.name).join(", ")
      } else {
        tidalArtist = track.artist.name;
      }
      
      trackList.push(
        {
          id: track.id,
          title: track.title,
          artist: tidalArtist,
          audioQuality: track.audioQuality,
          trackNumber: track.trackNumber,
          streamingUrl: audioSrc,
          albumArtUrl: tidalAlbumArt,
          index: index + 1
        }
      )
    })
    .catch(error => console.log(error));
  }

  return trackList;
}

export const start = (audioPlayer) => {
  const trackOne = tidalTracks.find(x => x.index === 1);
  tidalPlayer = new Audio(trackOne.streamingUrl);

  const track = {
    id: trackOne.id,
    artist: trackOne.artist,
    title: trackOne.title,
    image_url: trackOne.albumArtUrl
  }
  audioPlayer.updateTrack(track);
  
  tidalPlayer.addEventListener("canplaythrough", event => {
    // ready to play
  });

  tidalPlayer.addEventListener("seeked", event => {
    // playback seeked
  });

  tidalPlayer.addEventListener("ended", event => {
    playNextTrack(audioPlayer);
  });

  tidalPlayer.addEventListener('pause', () => {
    audioPlayer.setState('paused');
  }); 

  tidalPlayer.addEventListener('play', () => {
    if (seek_type === 'auto-next') {
      // Dont trigger this if the queue automatically moves to the next song
      canSeek = false;
    } else {
      canSeek = true;
    }
    seek_type = 'manual';

    audioPlayer.setState('playing');

    // if (!audioPlayer.currentTrack.id) {
    //   // First stream
    //   audioPlayer.startTimer();
    // } else if (audioPlayer.currentTrack && audioPlayer.currentTrack.id !== currentTidalTrack.id) {
    //   // Track changed
    //   audioPlayer.startTimer();
    // }

    audioPlayer.startTimer();
    const currentTrack = tidalTracks.find(track => track.id === audioPlayer.currentTrack.id)
    
    const track = {
      id: currentTrack.id,
      artist: currentTrack.artist,
      title: currentTrack.title,
      image_url: currentTrack.albumArtUrl
    }
    audioPlayer.updateTrack(track);
  });

  return tidalPlayer
}

export const queueTrack = (audioPlayer, track_index) => {
  const targetTrack = tidalTracks.find(x => x.index === track_index + 1);

  if (targetTrack) {
    tidalPlayer.src = targetTrack.streamingUrl;

    const track = {
      id: targetTrack.id,
      artist: targetTrack.artist,
      title: targetTrack.title,
      image_url: targetTrack.albumArtUrl
    }
    audioPlayer.updateTrack(track);
  }
  tidalPlayer.load()

  if (!mediaReady) {
    mediaReady = true;
  }
}

export const playNextTrack = (audioPlayer) => {
  // Automatically play the next track after the current track has ended
  const currentTrack = tidalTracks.find(track => track.id === audioPlayer.currentTrack.id)
  const nextTrack = tidalTracks.find(x => x.index === currentTrack.index + 1);

  if (nextTrack) {
    seek_type = 'auto-next';
    tidalPlayer.src = nextTrack.streamingUrl;
    tidalPlayer.play();

    const track = {
      id: nextTrack.id,
      artist: nextTrack.artist,
      title: nextTrack.title,
      image_url: nextTrack.albumArtUrl
    }
    audioPlayer.updateTrack(track);
  }
}

export const changeTrack = (audioPlayer, direction) => {
  tidalPlayer.pause();
  const currentTrack = tidalTracks.find(track => track.id === audioPlayer.currentTrack.id)
  const firstTrack = tidalTracks.find(track => track.index === 1);
  const nextTrack = tidalTracks.find(track => track.index === currentTrack.index + 1);
  const prevTrack = tidalTracks.find(track => track.index === currentTrack.index - 1);

  let targetTrack;
  if (direction === 'next') {
    if (nextTrack) {
      targetTrack = nextTrack;
    } else {
      targetTrack = firstTrack;
    }
  } else if (direction === 'prev') {
    if (prevTrack) {
      targetTrack = prevTrack;
    } else {
      targetTrack = firstTrack;
    }
  }
  tidalPlayer.src = targetTrack.streamingUrl;

  const track = {
    id: targetTrack.id,
    artist: targetTrack.artist,
    title: targetTrack.title,
    image_url: targetTrack.albumArtUrl
  }
  audioPlayer.updateTrack(track);
  tidalPlayer.play();
}